// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Vf-z","heading":"Wf-z"};